// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"iE-z","smallCardRow":"jE-z","largeCardRow":"kE-z","productSearchRow":"lE-z","curatedRow":"mE-z"};